module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.$route.name))])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.getInvoiceDocListFunc
    },
    model: {
      value: (_vm.commonFilter),
      callback: function($$v) {
        _vm.commonFilter = $$v
      },
      expression: "commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientNamenew",
      "option-value": "clientName",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": _vm.getInvoiceDocListFunc
    },
    model: {
      value: (_vm.clientFilter),
      callback: function($$v) {
        _vm.clientFilter = $$v
      },
      expression: "clientFilter"
    }
  })], 1), _vm._v(" "), (_vm.getInvoiceDocList.length > 0) ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getInvoiceDocList,
      "responsive": "",
      "fields": _vm.Invfields,
      "primary-key": "InvId",
      "per-page": _vm.pagination.perPage,
      "current-page": _vm.pagination.currentPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "InvId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "InvNO",
      fn: function(row0) {
        return [_c('span', [_vm._v("Inv NO : " + _vm._s(row0.item.InvNO)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Inv Date : " + _vm._s(row0.item.InvDate)), _c('br')])]
      }
    }, {
      key: "JOBNO",
      fn: function(row0) {
        return [_c('span', [_vm._v("Job NO : " + _vm._s(row0.item.JOBNO)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Job Date : " + _vm._s(row0.item.JOBDate)), _c('br')])]
      }
    }, {
      key: "fk_tally_id",
      fn: function(row1) {
        return [_c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "id": "show-btn",
            "size": "xs",
            "variant": row1.item.AddTypevalue == '1' ? 'info' : 'danger'
          },
          on: {
            "click": function($event) {
              _vm.addInv(row1.item)
            }
          }
        }, [_vm._v("\n                      " + _vm._s(row1.item.AddTypeLabel) + "\n                      "), _c('i', {
          staticClass: "fa fa-plus",
          attrs: {
            "aria-hidden": "true"
          }
        })])]
      }
    }])
  })], 1)]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [_vm._l((_vm.invArr), function(itm, idx) {
    return _c('b-card', {
      key: idx,
      staticClass: "mt-1"
    }, [_c('b-row', {
      attrs: {
        "align-v": "start"
      }
    }, [_c('b-col', {
      attrs: {
        "sm": "3"
      }
    }, [_c('label', [_vm._v("Invoice No "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('h5', [_c('b-badge', {
      attrs: {
        "variant": 'primary'
      }
    }, [_vm._v(_vm._s(itm.InvNO))])], 1), _vm._v(" "), (itm.invType_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invType_err))]) : _vm._e()]), _vm._v(" "), _c('b-col', {
      attrs: {
        "sm": "3"
      }
    }, [_c('label', [_vm._v("Job No "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('h5', [_c('b-badge', {
      attrs: {
        "variant": 'primary'
      }
    }, [_vm._v(_vm._s(itm.JOBNO))])], 1)]), _vm._v(" "), (idx != 0) ? _c('b-col', {
      attrs: {
        "sm": "3"
      }
    }, [_c('b-button', {
      staticClass: "ml-auto",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "id": "show-btn",
        "variant": "danger",
        "size": "xs"
      },
      on: {
        "click": function($event) {
          _vm.removeInv(idx)
        }
      }
    }, [_vm._v("\n                    Remove Inv "), _c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("Sent By :")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "fk_inv_doc_sent_by",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    model: {
      value: (_vm.invoiceDocDeatils.fk_inv_doc_sent_by),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "fk_inv_doc_sent_by", $$v)
      },
      expression: "invoiceDocDeatils.fk_inv_doc_sent_by"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Invoice Sent Through :")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('b-form-checkbox', {
    staticClass: "mr-2",
    attrs: {
      "id": "checkbox-Email",
      "name": "checkbox-Email",
      "value": "Email",
      "unchecked-value": ""
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_sent_trough_email),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_sent_trough_email", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_sent_trough_email"
    }
  }, [_vm._v("\n                    Email\n                  ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-Courier",
      "name": "checkbox-Courier",
      "value": "Courier",
      "unchecked-value": ""
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_sent_trough_courier),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_sent_trough_courier", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_sent_trough_courier"
    }
  }, [_vm._v("\n                    Courier\n                  ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-ByHand",
      "name": "checkbox-ByHand",
      "value": "By Hand",
      "unchecked-value": ""
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_sent_by_hand),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_sent_by_hand", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_sent_by_hand"
    }
  }, [_vm._v("\n                    By Hand\n                  ")])], 1)]), _vm._v(" "), (_vm.invoiceDocDeatils.inv_doc_sent_trough_email == 'Email') ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Email Date :")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "amount",
      "name": "amount",
      "type": "date"
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_date),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_date", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_date"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.invoiceDocDeatils.inv_doc_sent_trough_courier == 'Courier') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Docket No :")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "amount",
      "name": "amount",
      "type": "text"
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_Docket_No),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_Docket_No", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_Docket_No"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.invoiceDocDeatils.inv_doc_sent_trough_courier == 'Courier') ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Courier Date :")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "inv_doc_date_courier",
      "name": "inv_doc_date_courier",
      "type": "date"
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_date_courier),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_date_courier", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_date_courier"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.invoiceDocDeatils.inv_doc_sent_by_hand == 'By Hand') ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("By Hand Date :")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "amount",
      "name": "amount",
      "type": "date"
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_by_hand_date),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_by_hand_date", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_by_hand_date"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Remarks :")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.invoiceDocDeatils.inv_doc_remark),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "inv_doc_remark", $$v)
      },
      expression: "invoiceDocDeatils.inv_doc_remark"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Invoices Doc :")]), _vm._v(" "), _c('multi-file-uploader', {
    style: ('height: 80px; background: darkgray; width: 100%'),
    attrs: {
      "documentName": 'ReverseTallyInv_Doc_-',
      "otherDocName": 'ReverseTallyInv_Doc_-',
      "folderName": 'ReverseTallyInv_Doc',
      "accept": '*',
      "assign_no": 'ReverseTallyInv_Doc',
      "multiple": true,
      "state": Boolean(_vm.invoiceDocDeatils.singleUpload),
      "fileAllModuleId": 'InvoicesDoc'
    },
    model: {
      value: (_vm.invoiceDocDeatils.singleUpload),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDocDeatils, "singleUpload", $$v)
      },
      expression: "invoiceDocDeatils.singleUpload"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [(_vm.invoiceDocDeatils.singleUpload) ? _c('span', [(_vm.invoiceDocDeatils.singleUpload.length > 0) ? _c('b', _vm._l((_vm.sanitizedArray(_vm.invoiceDocDeatils.singleUpload)), function(item_doc, index_doc) {
    return _c('span', {
      key: index_doc
    }, [(item_doc != '') ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.printInvDoc(item_doc)
        }
      }
    }, [_vm._v("View Document - " + _vm._s(index_doc + 1))]) : _vm._e(), _vm._v(" "), _c('br')])
  })) : _c('b', [(
    _vm.invoiceDocDeatils.singleUpload != '' &&
    _vm.invoiceDocDeatils.singleUpload != undefined &&
    _vm.invoiceDocDeatils.singleUpload != null
  ) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.printInvDoc(_vm.invoiceDocDeatils.singleUpload)
      }
    }
  }, [_vm._v("View Document")]) : _vm._e()])]) : _vm._e()])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [(_vm.invArr.length > 0) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderSB"
    },
    on: {
      "click": _vm.addInvDetail
    }
  }, [_vm._v("Save & Submit\n                ")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSB"
    }
  })], 1)], 1)], 2)])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54aab22d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/invoice/addMultiInv.vue
// module id = 2638
// module chunks = 0